// /src/components/AnalyticsDashboard/AnalyticsDashboard.jsx
import React, { useState, useEffect } from "react"
import imgs from "../../Utils/assets/img/faces/5.jpg"
import {
  Bar,
  BarChart,
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"

import useLocalStorageState from "use-local-storage-state"
import { useNavigate } from "react-router-dom"
import { GetRequest } from "../../Utils/hooks/ApiHandler"
import {
  formatAmountInAlphabets,
  formatDate,
  formatToINR,
  putCommaInLeadsValue,
} from "../../Utils/helpers/commonhelper"
import img1 from "../../Utils/assets/img/faces/5.jpg"
import img2 from "../../Utils/assets/img/faces/6.jpg"
import img3 from "../../Utils/assets/img/faces/7.jpg"
import leads_no_data_found from "../../Utils/assets/img/leads_no_data_found.png"
import { Image } from "react-bootstrap"
import UnderProgress from "../tools/UnderProgress"

export default function AnalyticsDashboard() {
  useEffect(() => {
    // initialize any Bootstrap tooltips if needed
    try {
      /* global bootstrap */
      const tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      )
      tooltipTriggerList.forEach(function (tooltipTriggerEl) {
        // eslint-disable-next-line no-undef
        if (window.bootstrap && window.bootstrap.Tooltip) {
          new window.bootstrap.Tooltip(tooltipTriggerEl)
        }
      })
    } catch (e) {
      // ignore if bootstrap tooltip not available
    }

    // placeholder: if your project loads apexcharts and hrm-dashboard.js, they will run as before.
    // We do not import or run external scripts here.
  }, [])
  const [profitData, setProfitData] = useState([])

  const [customer, setCustomer] = useLocalStorageState("customer")
  const headers = {
    Authorization: customer?.token?.authorization,
    Authentication: customer?.token?.authentication,
  }
  const customerId = customer?.customer_details?.customer_id
  const userId = customer?.customer_details?.id
  const rf = customer?.token?.authentication
  const navigate = useNavigate()
  const extras = { customer, setCustomer, rf, navigate }
  const [revenue, setRevenue] = useState([])
  const imgArr = [img1, img2, img3]
  // getting random images function
  const getRandomImage = () => {
    const imgIndex = Math.floor(Math.random() * imgArr.length)
    return imgArr[imgIndex]
  }
  // state for deals summary
  const [dealsSumm, setDealsSumm] = useState({})

  // state for bill summary
  const [billSumm, setBillSumm] = useState()

  // upcoming event state
  const [upcomingEvent, setUpcomingEventData] = useState(null)

  const [barCount, setBarCount] = useState(0)

  //revenue client data
  const [revenueClientData, setRevenueClientData] = useState(null)

  // total revenue
  const [totalRevenue, setTotalrevenue] = useState(0)
  const [totalSales, setTotalSales] = useState(0)
  const [projection, setProjection] = useState(0)
  const [duration, setDuration] = useState("year")

  const getDate = (dated) => {
    const date = new Date(dated)
    let formattedDate
    if (date) {
      const day = String(date.getDate()).padStart(2, "0")
      const month = String(date.getMonth() + 1).padStart(2, "0")
      const year = date.getFullYear()
      formattedDate = `${day}/${month}/${year}`
    }
    return formattedDate
  }

  const fetchRevenueSummary = async () => {
    try {
      const res = await GetRequest(
        `dashboard/revenueAnalytics_year/${customerId}/${userId}`,
        { headers },
        { extras }
      )
      if (res.status === false) {
        return
      }
      const totalRevenue =
        res.data &&
        res.data.reduce((a, b) => parseFloat(a) + parseFloat(b?.revenue), 0)
      setTotalrevenue(totalRevenue)
      const totalSales =
        res.data &&
        res.data.reduce((a, b) => parseFloat(a) + parseFloat(b?.sales), 0)
      setTotalSales(totalSales)
      const totalProjection =
        res.data &&
        res.data.reduce((a, b) => parseFloat(a) + parseFloat(b?.Projection), 0)
      setProjection(totalProjection)
    } catch (error) {
      return
    }
  }
  const fetchRevenue = async () => {
    try {
      const res = await GetRequest(
        `dashboard/topRevenueClient/${customerId}/${userId}`,
        { headers },
        { extras }
      )
      if (res.status === false) {
        return
      }
      if (res.data) {
        const data = res.data?.map((c) => ({
          fullname: c.contact_name,
          email: c.email,
          budget: c.totalBudget,
        }))
        setRevenueClientData(data)
      }
    } catch (error) {
      return
    }
  }

  //  function for fetchimg the performance of the year graph

  const performanceByCategory = async () => {
    let endpoint
    try {
      if (duration === "year") {
        endpoint = `dashboard/categoryPerformance_year`
      }
      if (duration === "week") {
        endpoint = `dashboard/categoryPerformance_week`
      }
      if (duration === "sixmonth") {
        endpoint = `dashboard/categoryPerformance_halfYear`
      }
      if (duration === "month") {
        endpoint = `dashboard/categoryPerformance_month`
      }

      const res = await GetRequest(
        `${endpoint}/${customerId}/${userId}`,
        { headers },
        { extras }
      )
      if (res.status === false) {
        return
      }
      setBarCount(res.data.length)

      const data = res.data?.map((c) => ({
        ...c,
        month: c.month,
        // month: c.month?.slice(0, 3),
      }))
      setProfitData(data)
    } catch (error) {
      return
    }
  }

  useEffect(() => {
    performanceByCategory()
  }, [duration])

  useEffect(() => {
    fetchRevenue()
    fetchRevenueSummary()
  }, [])

  // deals summary
  useEffect(() => {
    ;(async () => {
      try {
        const res = await GetRequest(
          `dashboard/dealsSummary/${customerId}/${customer.customer_details?.id}`,
          { headers },
          extras
        )
        if (res.status === false) {
          return
        }
        setDealsSumm(res.data && res.data)
      } catch (error) {
        return
      }
    })()
  }, [])
  // bills summary
  useEffect(() => {
    ;(async () => {
      try {
        const res = await GetRequest(
          `dashboard/billSummary/${customerId}/${customer.customer_details?.id}`,
          { headers },
          extras
        )
        if (res.status === false) {
          return
        }
        if (res.data) {
          setBillSumm(
            res.data?.map((c) => {
              const parsedItems = JSON.parse(c.items)
              const totalBudget = formatToINR(parsedItems[0]["grand-total"])
              return {
                invoice_no: c.invoice_number,
                fullname: c.contact_name,
                email: c.email,
                due_date: getDate(c.due_date),
                amount: totalBudget,
              }
            })
          )
        }
      } catch (error) {
        return
      }
    })()
  }, [])

  const formatTime = (timeStr) => {
    const [hours, minutes] = timeStr.split(":")
    const hour = parseInt(hours)
    const ampm = hour >= 12 ? "PM" : "AM"
    const formattedHour = hour % 12 || 12 // Convert 0 to 12, 13 to 1, etc.
    return `${formattedHour}:${minutes}${ampm}`
  }
  // upcoming events
  useEffect(() => {
    ;(async () => {
      try {
        const res = await GetRequest(
          `dashboard/upcomingEvent/${customerId}/${customer.customer_details?.id}`,
          { headers },
          extras
        )
        if (res.status === false) {
          return
        }
        if (res.data) {
          const data = Object.entries(res.data)?.map(([key, value]) => ({
            feedback: value.feedback,
            date: value.created_at?.split(" ")[0],
            time: value.created_at?.split(" ")[0],
            next_followup: value.next_followup?.split(" ")[0],
            created_at: value.created_at?.split(" ")[0],
            status: value.status,
          }))
          setUpcomingEventData(data)
        }
      } catch (error) {
        return
      }
    })()
  }, [])

  // custome tick in graph
  const CustomTick = ({ x, y, payload }) => {
    if (duration === "year" || duration === "sixmonth") {
      return (
        <text x={x} y={y + 10} fontSize={10} textAnchor="middle" fill="#666">
          {String(payload.value || "").slice(0, 3)}
        </text>
      )
    }

    const parts = String(payload.value || "").split(" ")
    return (
      <text x={x} y={y + 10} fontSize={10} textAnchor="middle" fill="#666">
        <tspan x={x} dy="0">
          {parts[0] || ""}
        </tspan>
        <tspan x={x} dy="15">
          {parts[1] || ""}
        </tspan>
      </text>
    )
  }

  return (
    <div>
      {/* Inject original CSS block to keep exact styling (you can later move this into AnalyticsDashboard.css) */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
            body{
                    background: #f3f3f3;
            }
            .text-truncate {
                font-size: 13px !important;
            }
         .card.custom-card{
                border: 1px solid #cfeaf3;
    box-shadow: 0px 0px 15px #e9e9e9;
         }
.nav-underline .nav-link.active, .nav-underline .show>.nav-link{
    border: none;
    border-bottom: 2px solid;
    border-radius: 0;
        height: 100%;
        cursor: pointer;
    padding-bottom: 0px;
    display: flex;
    align-items: center;
}
.nav-underline .nav-link{
    height: 100%;
    padding-bottom: 0px;
    display: flex;
    border: none;
    font-size: .87rem;
    align-items: center;
    color: #767676;

}

.logo {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .logo img {
      width: 35px;
      height: 35px;
    }

    .logo span {
      font-weight: 700;
      font-size: 18px;
    }

    .icons {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .icons img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }

    .icons .plus {
      width: 32px;
      height: 32px;
      border: 1px solid #ddd;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      cursor: pointer;
    }

    /* Navigation */
    .nav {
      display: flex;
      gap: 25px;
      margin-bottom: 30px;
    }

    .nav a {
      text-decoration: none;
      font-weight: 500;
      color: #666;
      padding: 8px 15px;
      border-radius: 20px;
      transition: 0.3s;
    }

    .nav a.active {
      color: #111;
      border: 1px solid #bbb;
      background: linear-gradient(to right, #1FA2FF 0%, #12D8FA  100%, #1FA2FF  100%) !important;
    }

    /* Cards container */
    .cards {
      display: flex;
      gap: 13px;

    }

    .card {
      flex: 1;
      background: #fff;
      border: 1px solid #dad7d7;
      border-radius: 10px;
          margin-bottom: 13px !important;
    }

    .card h4 {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .status {
      font-size: 12px;
      font-weight: 500;
      padding: 3px 8px;
      border-radius: 20px;
    }

    .positive {
      background: #e6f8f0;
      color: #0b9c60;
    }

    .negative {
      background: #fce8e8;
      color: #d93025;
    }

    .value {
      font-size: 23px;
      font-weight: 700;
      margin-bottom: 5px;
    }

    .compare {
      font-size: 13px;
      color: #777;
    }
    .navs {
      display: flex;
          gap: 12px;
    margin-bottom: 0px;
    margin-left: 12px;
    align-items: center;
    }

    .navs a {
      text-decoration: none;
      font-weight: 500;
      color: #666;
      padding: 6px 15px;
      border-radius: 20px;
      transition: 0.3s;
        font-size: 13px;
    border: 1px solid #12D8FA;
    background: #f9f9f900;
    }

    .navs a.active {
      color: #fff;
         border: 1px solid #12D8FA;
    background: linear-gradient(to right, #5d5fef 0%, #12D8FA  100%, #1FA2FF  100%);
    }

   

    /* Card Style */
    .Projectscard {
      background: #fff;
    border-radius: 8px;
    /* box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05); */
    box-shadow: none !important;
      border: 1px solid #dad7d7 !important;
    padding: 15px;

    }

    .Projectscard .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
          padding: 0rem .2rem 0.5rem !important;
    }

    .card-header h3 {
      font-size: 16px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .card-header span {
      font-size: 14px;
      color: #777;
    }

    /* Projects */
    .projects-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 15px;
    }

    .project-item {
      display: flex;
      align-items: flex-start;
      gap: 12px;
    }

    .project-icon {
      width: 42px;
      height: 42px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      font-weight: bold;
      color: #555;
      background: #f5f5f5;
    }

    .project-info h4 {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 4px;
    }

    .project-info p {
      font-size: 12px;
      color: #777;
    }

    /* Calendar */
    .calendar {
      margin-top: 10px;
    }

    .calendar-days .day:last-child,
    .calendar-days .day:first-child{
color: gray;
    }
    .calendar-days .day:last-child:hover,
    .calendar-days .day:first-child:hover{
    background: #f2f2f2;
    color: black !important;
    }

    .calendar-days {

      display: flex;
      justify-content: space-between;
      text-align: center;
      margin-bottom: 20px;
         gap: 5px;
    padding: 0px 0px 0px;
    }

    .day {
       flex: 1;
    padding: 0px 0;
    border-radius: 5px;
    font-size: 11px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 0px;
    max-width: 43px;
    column-gap: 1px;
    height: 41px;
    align-items: center;
    padding-right: 0px;
    justify-content: center;
    }
    .day span{
            margin-top: -4px;
    }

    .day.active {
      background: #5d5fef;
      color: #fff;
      font-weight: 600;
    }

    /* Meeting Card */
    .meeting {
      background: #f5f4fe;
      border-radius: 14px;
      padding: 15px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-bottom: 10px;
    }

    .meeting h4 {
      font-size: 14px;
      font-weight: 600;
          margin-bottom: 4px;
    }

    .meeting span {
      font-size: 12px;
      color: #666;
    }

    .meeting-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
      .recharts-bar-rectangle:hover {
    stroke: none !important;
}

.recharts-active-bar {
    stroke: none !important;
    stroke-width: 0 !important;
}

.recharts-bar-rectangle {
    stroke: none !important;
}

    .meet-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      background: #fff;
      border-radius: 8px;
      padding: 5px 10px;
      font-size: 12px;
      font-weight: 500;
      border: 1px solid #ddd;
    }

    .avatars {
      display: flex;
      align-items: center;
    }

    .avatars img {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      border: 2px solid #fff;
      margin-left: -8px;
    }

    .more {
      background: #5d5fef;
      color: #fff;
      border-radius: 50%;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 600;
      margin-left: -8px;
      border: 2px solid #fff;
    }

      .section {
            background-color: white;
            border-radius: 8px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
            margin-bottom: 20px;
            overflow: hidden;
        }
        
        .section-header {
            padding: 16px 20px;
            border-bottom: 1px solid #eef0f3;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        
        .section-title {
            font-size: 14px;
            font-weight: 600;
            color: #5f6b7c;
        }
        
        .task-count {
            font-size: 12px;
            color: #8a94a6;
            margin-left: 8px;
        }
        
        .task-table {
            width: 100%;
            border-collapse: collapse;
        }
        
        .task-table th {
            text-align: left;
            padding: 12px 20px;
            font-size: 12px;
            font-weight: 600;
            color: #8a94a6;
            border-bottom: 1px solid #eef0f3;
        }
        
        .task-table td {
            padding: 16px 20px;
            border-bottom: 1px solid #eef0f3;
        }
        
        .task-name {
            font-weight: 500;
                width: 70%;
        }
       .task-name div p{
                display: -webkit-box !important;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: .85rem !important;
        }
        .priority {
            display: inline-block;
            padding: 2px 8px;
            border-radius: 4px;
            font-size: 10px;
            font-weight: 500;
        }
        
        .priority-high {
            background-color: #fbc0c1;
            color: black;
        }
        
        .priority-low {
            background-color: #e8f4ff;
            color: black;
        }
        
        .due-date {
            font-size: 12px !important;
            color: #777 !important;
            font-weight: 400;
        }
        
        .today {
            color: #e74c3c !important;
            font-weight: 500;
        }
        
        .days-left {
            color: #8a94a6 !important;
        }
        
        .add-task {
            padding: 3px 8px;
            width: fit-content;
            color: #3498db;
            font-weight: 500;
            cursor: pointer;
            border: 1px solid lightblue;
            border-radius: 20px ;
        }
        
     
        .empty-section {
            padding: 40px 20px;
            text-align: center;
            color: #8a94a6;
            font-size: 14px;
        }
        
        .status-dot {
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-right: 8px;
        }
        
        .in-progress-dot {
            background-color: #3498db;
        }
        
        .todo-dot {
            background-color: #f39c12;
        }
        
        .upcoming-dot {
            background-color: #9b59b6;
        }
        .Projectscard table thead tr th{
             font-weight: 500 !important;
    font-size: 11px;
    color: #888;
    padding: 10px 1px 10px;
    border-bottom: 1px solid #bcefff;

        }
        .Projectscard .accordion-item{
            border: none !important;

        }
        .Projectscard .accordion-button{
border: none !important;
    background: none !important;
    outline: none !important;
    box-shadow: none !important;
        }
        .Projectscard table tbody tr td:nth-child(2), .Projectscard table tbody tr td:last-child,
        .Projectscard table thead tr th:nth-child(2), .Projectscard table thead tr th:last-child{
text-align: end !important;
        }
        .Projectscard table tbody tr td .from-check-input{
width: 12px !important;
background-color: lightblue;
 
        }
        .Projectscard table tbody tr td{
           padding: 10px 0px !important;
           color: #141414;
           border-color: #bcefff !important;
        }
       .Projectscard .accordion-button:focus:not(:focus-visible){
border: none !important;
    background: none !important;
    outline: none !important;
        }
        div.card-header.calendars{
            padding-bottom: 0px !important;
            /* border: none !important; */
        }

        .followupsTable tbody tr td{
padding: 10px 10px;
 font-size: 13px !important;
     font-weight: 500;
    color: #323232 ;
        }
        .followupsTable thead tr th{
            padding: 10px 10px;
            font-size: 12px !important;
            font-weight: 500 !important;
            color: #777 !important;
            border-bottom: 1px solid #d8f2fa;
        }
     
        .lastThAndTd{
position: sticky;
right: 0;
        }
        .followupsCardsTable{
             border: 1px solid #dad7d7 !important;
        }
        .namesTdP{
                font-weight: 500 !important;
    font-size: 14px !important;
    line-height: 1.45 !important;
        }
        .followupsTable td span.badge.rounded-pill{
               font-size: 10px !important;
    font-weight: 500 !important;
        }
        .crm-timeline-content span{
font-size: 13px;
        }
        .card-title{
                font-size: 17px !important;

        }
        .buttonDashboard.active{
                background: linear-gradient(to right, rgb(var(--secondary-rgb)) 0, #6789d8 100%);
    color: #fff;
    padding: 9px 12px;
    border-radius: 29px;

      }
      .buttonDashboard{
        border-radius: 29px;
        font-size: 13px;
        border: 1px solid #00b6f1;
        color: black;
        font-weight: 600;
        margin-right: 8px;
        padding: 9px 12px;
      }
      .page-heading{
          font-size: 2rem;
          font-weight: 400 !important;
      }
       .tab {
          border: 1px solid #00b6f1;
          border-radius: 14px;
          color: black;
          font-weight: 600;
          font-size: 13px;
          padding: 8px 16px;
          text-decoration: none;
          cursor : pointer;
        }
        .tab.active {
            background: linear-gradient(to right, #00b6f1 0, #6789d8 100%);
            color: white;
        }
        `,
        }}
      />

      {/* Begin converted HTML (JSX) */}

      {/* main-content */}
      <div className="main-content">
        <div className="">
          {/* Page Header */}
          {/* <div className="d-md-flex d-block align-items-center justify-content-between my-4 mt-3 page-header-breadcrumb">
            <div>
              <p className="fw-semibold fs-24 mb-0">Sales Dashboard</p>
              <span className="fs-semibold text-muted">Track your sales activity, leads and deals here.</span>
            </div>
          </div> */}
          {/* <div
            className="d-flex align-items-center justify-content-center"
            style={{
              height: "calc(100vh-10rem)",
            }}
          >
            <Image
              src={leads_no_data_found}
              className="img-fluid mx-auto "
              style={{ maxWidth: "300px" }}
            />
          </div> */}
          <div className="d-flex justify-content-center align-items-center">
            <UnderProgress />
          </div>
        </div>
      </div>
      {/* End main-content */}
    </div>
  )
}
